import { ElementRef } from '@angular/core';
import { SortOrder } from '../../../../../core/api/api';
import { ProductReference } from '../../../../../core/api/api.entities';
import { ProductsApi } from '../../../../../core/api/products/products-api.service';
import { SelectedProductService } from '../../../../../core/services/selected-product.service';
import { DashboardProductForm } from '../../../../../forms/forms/dashboard-product.form';
import { links } from '../../../../../shared/constants/links.constants';
import { formatCurrentStock } from '../../../../../shared/utils/formatters.utils';
import { convertProductReferenceToProductOption } from '../../../../../shared/utils/product.utils';

export abstract class ProductSelectComponent {
  abstract barcodeInput: ElementRef<HTMLInputElement>;

  products: ProductReference[] = [];

  sort = ['productCategory.name', 'brand', 'productName'].map(column => ({ column, order: SortOrder.asc }));

  constructor(
    private productsApi: ProductsApi,
    private service: SelectedProductService
  ) {}

  protected selectBarcodeInput(): void {
    setTimeout(() => {
      this.barcodeInput.nativeElement.focus();
      this.barcodeInput.nativeElement.select();
    }, 100);
  }

  protected unsubscribe(): void {
    this.service.productChangeListener?.unsubscribe();
  }

  get currentStock(): string | null {
    const product = this.service.product;

    if (product) {
      return formatCurrentStock(product.activeStockItems, product.quantityUnitStock);
    } else return null;
  }

  get form(): DashboardProductForm {
    return this.service.productForm;
  }

  get isLoading(): boolean {
    return this.service.state.isLoading;
  }

  get productSelected(): boolean {
    return !!this.service.product;
  }

  clearProduct(): void {
    this.service.clearSelectedProduct();

    setTimeout(() => {
      this.barcodeInput.nativeElement.click();
      this.barcodeInput.nativeElement.focus();
      this.form.controls.product.markAsUntouched();
    }, 100);
  }

  openProductPage(): void {
    const product = this.service.product;

    if (product) {
      window.open(links.productCategories.viewOne(product.productCategoryId), '_blank');
    }
  }

  refreshProductOptions(): void {
    this.loadData();
  }

  protected loadData(): void {
    this.productsApi.findAllCompact({ sort: this.sort }).subscribe(products => {
      this.products = products;
      this.form.options.products = products.map(convertProductReferenceToProductOption);
      this.service.setBarcodeChangeListener();
      this.service.setProductChangeListener(products);
      this.setSubmissionListener();
    });
  }

  private setSubmissionListener(): void {
    this.service.submission.subscribe(() => {
      this.barcodeInput.nativeElement.focus();
      this.barcodeInput.nativeElement.select();
    });
  }
}
